/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramCategoryControllerGetMetaTreeShallowQueryResponse } from '../types/TelegramCategoryControllerGetMetaTreeShallow.ts';

function getTelegramCategoryGetMetaTreeShallowUrl() {
  const res = { method: 'GET', url: `/api/telegram/category/meta-tree/shallow` as const };
  return res;
}

/**
 * {@link /api/telegram/category/meta-tree/shallow}
 */
export async function telegramCategoryGetMetaTreeShallow(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramCategoryControllerGetMetaTreeShallowQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getTelegramCategoryGetMetaTreeShallowUrl().url.toString(), ...requestConfig });
  return res.data;
}
